import React from 'react';
import { Resource } from '../../../../common/constants/resource';
import { RxApplicationDetails } from '../../../tasks/types/rx';
import {
  calculateAgeFromDob,
  dateToString,
  genderShortFormToLongForm,
  valueToString,
} from '../../utilities/formattingUtilities';
import { TaskDetailsItem } from '../components/TaskDetailsItem';

export const RxApplicationSection = (
  rxApplicationDetails: RxApplicationDetails,
) => {
  if (!rxApplicationDetails.recordExists || rxApplicationDetails.recordClear) {
    return (
      <>
        <TaskDetailsItem
          leftItem={Resource.RX_HIT_TYPE}
          rightItem={
            rxApplicationDetails.recordClear
              ? Resource.RX_CLEAR
              : Resource.RX_HIT_TYPE_NO_HIT
          }
        />
      </>
    );
  }

  return (
    <>
      <TaskDetailsItem
        leftItem={Resource.RX_HIT_TYPE}
        rightItem={Resource.RX_HIT_TYPE_HIT}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_APPLICANT_NAME}
        rightItem={rxApplicationDetails.name || Resource.NORA_M_DASH}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_APPLICANT_GENDER_AND_AGE}
        rightItem={`${
          rxApplicationDetails.gender
            ? genderShortFormToLongForm(rxApplicationDetails.gender)
            : Resource.NORA_M_DASH
        }, ${
          rxApplicationDetails.dob
            ? calculateAgeFromDob(rxApplicationDetails.dob)
            : Resource.NORA_M_DASH
        }`}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_APPLICANT_BIRTH_DATE}
        rightItem={dateToString(rxApplicationDetails.dob)}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_MAX_SEVERITY}
        rightItem={valueToString(rxApplicationDetails.riskScore)}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_COUNT}
        rightItem={valueToString(rxApplicationDetails.fillCount)}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_HIGH}
        rightItem={valueToString(rxApplicationDetails.high)}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_MEDIUM}
        rightItem={valueToString(rxApplicationDetails.medium)}
      />
      <TaskDetailsItem
        leftItem={Resource.RX_LOW}
        rightItem={valueToString(rxApplicationDetails.low)}
      />
    </>
  );
};
